import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';

export default class ToggleDescription extends Component {
  state = {
    showAll: false,
  };

  handleClick = () => {
    const { showAll } = this.state;
    this.setState({ showAll: !showAll });
  };

  p = { clientHeight: 100 };

  render() {
    const { data, defaultHeight, moreLessText } = this.props;
    const { showAll } = this.state;
    const paragraphHeight = this.p.clientHeight;
    const addExtraHeight =
      paragraphHeight < defaultHeight ? paragraphHeight + 10 : `${defaultHeight}px`;
    return (
      <Fragment>
        <div
          className={`colasp ${showAll ? 'active' : ''}`}
          style={{
            height: showAll ? paragraphHeight : addExtraHeight,
          }}
        >
          <div ref={p => (this.p = p)}>{data}</div>
        </div>
        {!(paragraphHeight < 90) && (
          <Button className="read-more mt-2" onClick={this.handleClick}>
            {showAll ? `${moreLessText} Less` : `${moreLessText} More`}
          </Button>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Places/ToggleDescription.jsx